import React, { useState } from "react";
import { Layout, Typography, Collapse, Select } from "antd";

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { Panel } = Collapse;
const { Option } = Select;

const policyItemsDE = [
  {
    title: "Welche Informationen wir erheben",
    content:
      "Wir erheben personenbezogene Daten, die Sie uns zur Verfügung stellen, wie z. B. Name, E-Mail-Adresse und alle weiteren Informationen, die Sie freiwillig angeben.",
  },
  {
    title: "Wie wir Ihre Informationen nutzen",
    content:
      "Wir verwenden die gesammelten Daten, um unsere Dienste bereitzustellen und zu verbessern, mit Ihnen zu kommunizieren und rechtlichen Verpflichtungen nachzukommen.",
  },
  {
    title: "Datensicherheit",
    content:
      "Wir setzen angemessene technische und organisatorische Maßnahmen ein, um Ihre Daten gegen unbefugte Verarbeitung, Verlust oder Zerstörung zu schützen.",
  },
  {
    title: "Ihre Rechte",
    content:
      "Sie haben das Recht, jederzeit auf Ihre Daten zuzugreifen, sie zu berichtigen oder löschen zu lassen. Unter bestimmten Voraussetzungen können Sie auch der Verarbeitung widersprechen oder eine Einschränkung verlangen.",
  },
  {
    title: "Änderungen dieser Richtlinie",
    content:
      "Wir können diese Datenschutzerklärung gelegentlich aktualisieren. Wir informieren Sie über Änderungen, indem wir die neue Version hier veröffentlichen.",
  },
];

const policyItemsEN = [
  {
    title: "Information We Collect",
    content:
      "We collect personal information that you provide to us, such as your name, email address, and any other information you choose to provide.",
  },
  {
    title: "How We Use Your Information",
    content:
      "We use the information we collect to provide and improve our services, communicate with you, and comply with legal obligations.",
  },
  {
    title: "Data Security",
    content:
      "We implement appropriate technical and organizational measures to protect your personal information against unauthorized or unlawful processing, accidental loss, destruction, or damage.",
  },
  {
    title: "Your Rights",
    content:
      "You have the right to access, correct, or delete your personal information. You may also have the right to restrict or object to certain processing of your data.",
  },
  {
    title: "Changes to This Policy",
    content:
      "We may update this privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page.",
  },
];

const PrivacyPolicy = () => {
  const [lang, setLang] = useState("de"); // lokal: "de" oder "en"

  const policyItems = lang === "de" ? policyItemsDE : policyItemsEN;
  const titleText = lang === "de" ? "Datenschutzerklärung" : "Privacy Policy";
  const updatedText = lang === "de" ? "Letzte Aktualisierung" : "Last updated";

  return (
    <Layout className="min-h-screen bg-gray-100">
      <Content className="p-4 md:p-8 max-w-3xl mx-auto">
        <div className="bg-white shadow-md rounded-lg p-6 md:p-8">
          {/* Sprache wählen */}
          <div className="flex justify-end mb-4">
            <Select value={lang} onChange={setLang} style={{ width: 80 }}>
              <Option value="de">DE</Option>
              <Option value="en">EN</Option>
            </Select>
          </div>

          {/* Überschrift */}
          <Title level={2} className="text-center mb-6">
            {titleText}
          </Title>

          {/* Datum */}
          <Paragraph className="mb-6">
            {updatedText}:{" "}
            {new Date().toLocaleDateString(lang === "de" ? "de-DE" : "en-US")}
          </Paragraph>

          {/* Akkordeon */}
          <Collapse defaultActiveKey={["0"]}>
            {policyItems.map((item, idx) => (
              <Panel header={item.title} key={idx}>
                <Paragraph>{item.content}</Paragraph>
              </Panel>
            ))}
          </Collapse>
        </div>
      </Content>
    </Layout>
  );
};

export default PrivacyPolicy;
